export default __webpack_public_path__ + "static/media/FirstBase-7.79bd8ea7.jpg";